import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { NativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { MatLegacySliderModule } from '@angular/material/legacy-slider';
import { MatLegacyTabsModule } from '@angular/material/legacy-tabs';

import 'hammerjs';

import { environment as ENV } from '../../environments/environment';

import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ButtonComponent } from './button/button.component';
import { CardComponent } from './card/card.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { FileUploadComponent } from './file-upload/file-upload.component';

import { InputComponent } from './input/input.component';
import { LabelComponent } from './label/label.component';
import { ListComponent } from './list/list.component';
import { OcrUploadComponent } from './ocr-upload/ocr-upload.component';
import { ProgressComponent } from './progress/progress.component';
import { SliderComponent } from './slider/slider.component';
import { TabComponent } from './tab/tab.component';
import { TabGroupComponent } from './tab/tab-group.component';
import { UserHistoryComponent } from './user-history/user-history.component';
import { UserStatusComponent } from './user-status/user-status.component';


import { FileUploadService } from './file-upload/file-upload.service';

import { TitleCasePipe } from './title-case.pipe';
import { ApplicantService } from 'app/laas/applicant.service';

import { ButtonNoLabelComponent } from './button-no-label/button-nolabel.component';

import { InputNoLabelComponent } from './input-nolabel/input-nolabel.component';
import { InputNoLabelwmComponent } from './input-nolabelwm/input-nolabelwm.component';
import { AutocompleteNoLabelComponent } from './autocomplete-NoLabel/autocomplete-nolabel.component';
import { SpinnerComponent } from './spinner/spinner.component';

import { SpinnerOverlayComponent } from './spinner-wrapper/spinner-overlay-wrapper.component';
import { AutocompleteBiComponent } from './autocomplete-bilingual/autocomplete.component';
import { DateInputComponent } from './date-input/date-input.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { AdvancedFilterComponent } from './advanced-filter/advanced-filter.component';
import { DateRangeFilterComponent } from './data-range-filter/date-range-filter.component';
import { MatLegacyAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { FileDragUploadComponent } from './file-drag-upload/file-drag-upload.component';
import { FileDownloadModalComponent } from './file-download-modal/file-download-modal.component';
import { FilterSelectComponent } from './filter-select/filter-select.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,

    NativeDateModule,
    MatLegacyAutocompleteModule,
    MatLegacyInputModule,
    MatLegacyCardModule,
    MatDatepickerModule,
    MatLegacySelectModule,
    MatLegacyProgressBarModule,
    MatLegacySliderModule,
    MatLegacyTabsModule,
    MatIconModule,
    MatLegacyCheckboxModule,
    
    // AgmCoreModule.forRoot({
    //   apiKey: ENV.googleAddress.apiKey,
    //   libraries: ENV.googleAddress.libraries,
    // }),
  ],
  declarations: [
    AutocompleteComponent,
    AutocompleteBiComponent,

    ButtonComponent,
    CardComponent,
    DatepickerComponent,

    FileUploadComponent,

    InputComponent,
    InputNoLabelComponent,
    InputNoLabelwmComponent,
    LabelComponent,
    ListComponent,
    OcrUploadComponent,
    ProgressComponent,
    SliderComponent,
    TabComponent,
    TabGroupComponent,
    UserHistoryComponent,
    UserStatusComponent,
    TitleCasePipe,
    ButtonNoLabelComponent,
    AutocompleteNoLabelComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    DateInputComponent,
    SearchInputComponent,
    AdvancedFilterComponent,
    DateRangeFilterComponent,
    FileDragUploadComponent,
    FileDownloadModalComponent,
    FilterSelectComponent,
  ],
  exports: [
    AutocompleteComponent,
    AutocompleteBiComponent,
    ButtonComponent,
    CardComponent,
    DatepickerComponent,

    FileUploadComponent,

    InputComponent,
    InputNoLabelComponent,
    InputNoLabelwmComponent,
    LabelComponent,
    ListComponent,
    OcrUploadComponent,
    ProgressComponent,
    SliderComponent,
    TabComponent,
    TabGroupComponent,
    UserHistoryComponent,
    UserStatusComponent,
    TitleCasePipe,
    ButtonNoLabelComponent,
    AutocompleteNoLabelComponent,
    SpinnerComponent,
    SpinnerOverlayComponent,
    DateInputComponent,
    SearchInputComponent,
    AdvancedFilterComponent,
    DateRangeFilterComponent,
    FileDragUploadComponent,
    FileDownloadModalComponent,
    FilterSelectComponent
  ],
  providers: [FileUploadService],
})
export class CoreModule {}
